angular.module('picmonicng').directive('workflowSidebar', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/workflow-sidebar.html',
      controller: [
        '$scope',
        '$filter',
        'WorkflowService',
        'UserService',
        'PermissionsService',
        'toaster',
        function ($scope, $filter, WorkflowService, UserService, PermissionsService, toaster) {
          $scope.tab = 'overview';
          $scope.selectedTask = {};
          $scope.categoryAccordion = { filters: false };
          $scope.taskFilters = {};
          $scope.stateFilters = {};

          $scope.UserService = UserService;
          $scope.PermissionsService = PermissionsService;

          $scope.taskFilters.assignee_id = UserService.user.user_id;

          $scope.$watch(
            function () {
              return WorkflowService.workflow;
            },
            function (value, value1) {
              for (var a in WorkflowService.workflow.states) {
                if (parseInt(WorkflowService.workflow.states[a].is_active, 10) == 1) {
                  $scope.categoryAccordion[WorkflowService.workflow.states[a].workflow_state_id] = true;
                } else {
                  $scope.categoryAccordion[WorkflowService.workflow.states[a].workflow_state_id] = false;
                }
              }
            }
          );

          $scope.selectTab = function (tab) {
            $scope.tab = tab;
            WorkflowService.sidebarOpen = true;
          };

          $scope.toggleAccordion = function (category) {
            $scope.categoryAccordion[category] = !$scope.categoryAccordion[category];
          };

          $scope.newTask = function () {
            $scope.selectedTask = {
              workflow_id: WorkflowService.workflow.workflow_id,
              is_required: 1,
            };

            $scope.selectTab('newTask');
          };

          $scope.selectTask = function (task, state) {
            $scope.selectedTask = task;
            $scope.selectedTask.time_spent_hours = Math.floor($scope.selectedTask.time_spent / 60);
            $scope.selectedTask.time_spent_mins = $scope.selectedTask.time_spent % 60;
            $scope.selectedTask.assigned_on = Math.max(state.activated_at, $scope.selectedTask.created_at);
            $scope.selectedState = state;

            $scope.selectTab('task');
          };

          $scope.editTask = function (task) {
            $scope.selectedTask = task;
            $scope.selectTab('newTask');
          };

          $scope.saveTask = function () {
            if (
              !$scope.selectedTask.completed_at ||
              $scope.selectedTask.time_spent_hours > 0 ||
              $scope.selectedTask.time_spent_mins > 0
            ) {
              var promise = WorkflowService.saveTask($scope.selectedTask);

              if ($scope.selectedTask.workflow_task_id) {
                promise.then(function (data) {
                  $scope.selectTab('overview');
                });
              } else {
                promise.then(function (data) {
                  $scope.selectTask(data, { activated_at: data.created_at });
                });
              }
            } else {
              toaster.error('Time on Task must be entered!');
            }
          };

          $scope.deleteTask = function (task, state) {
            if (confirm('Are you sure you want to delete this task?')) {
              WorkflowService.deleteTask(task, state);
            }
          };

          $scope.completeTask = function (task, state, $event) {
            $event.stopPropagation();
            $scope.selectTask(task, state);
            WorkflowService.completeTask(task);
          };

          $scope.addTaskFilter = function (filter, value) {
            $scope.taskFilters[filter] = value;
          };

          $scope.removeTaskFilter = function (filter) {
            delete $scope.taskFilters[filter];
          };

          $scope.toggleTaskFilter = function (filter, onVlaue) {
            if ($scope.taskFilters[filter]) {
              $scope.removeTaskFilter(filter);
            } else {
              $scope.addTaskFilter(filter, onVlaue);
            }
          };

          $scope.toggleStateFilter = function (filter) {
            $scope.stateFilters[filter] = !$scope.stateFilters[filter];
          };

          $scope.getStateFilters = function () {
            var stateFilters = {};

            if ($scope.taskFilters.assignee_id) {
              stateFilters.is_active = '1';
            }

            return stateFilters;
          };
        },
      ],
    };
  },
]);
